import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NaslovnicaComponent } from './naslovnica/naslovnica.component';
import { CpanelComponent } from './cpanel/cpanel.component';
import { AktivacijaComponent } from './aktivacija/aktivacija.component';
import { RegistracijaComponent } from './registracija/registracija.component';
import { PrisutniComponent } from './prisutni/prisutni.component';
import { ClanoviComponent } from './clanovi/clanovi.component';
import { ClanEditComponent } from './clan-edit/clan-edit.component';
import { ObavijestiPanelComponent } from './obavijesti-panel/obavijesti-panel.component';
import { GrupeComponent } from './grupe/grupe.component';
import { GrupaClanoviComponent } from './grupa-clanovi/grupa-clanovi.component';
import { ClanarineComponent } from './clanarine/clanarine.component';
import { TerminiPregledComponent } from './termini-pregled/termini-pregled.component';
import { ClanarinePregledComponent } from './clanarine-pregled/clanarine-pregled.component';
import { StatKlijentComponent } from './stat-klijent/stat-klijent.component';
import { StatKlPosjeteComponent } from './stat-kl-posjete/stat-kl-posjete.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/naslovnica',
    pathMatch: 'full'
  },
  {
    path: 'naslovnica',
    component: NaslovnicaComponent
  },
  {
    path: 'cpanel1',
    component: CpanelComponent
  },
  {
    path: 'aktivacija',
    component: AktivacijaComponent
  },
  {
    path: 'registracija',
    component: RegistracijaComponent
  },
  {
    path: 'prisutni',
    component: PrisutniComponent
  },
  {
    path: 'clanovi',
    component: ClanoviComponent
  },
  {
    path: 'clan',
    component: ClanEditComponent
  },
  {
    path: 'clanarine',
    component: ClanarineComponent
  },
  {
    path: 'obavijesti-panel',
    component: ObavijestiPanelComponent
  },
  {
    path: 'grupe',
    component: GrupeComponent
  },
  {
    path: 'grupa-clanovi',
    component: GrupaClanoviComponent
  },
  {
    path: 'termini-pregled',
    component: TerminiPregledComponent
  },
  {
    path: 'clanarine-pregled',
    component: ClanarinePregledComponent
  },
  {
    path: 'stat-klijent',
    component: StatKlijentComponent
  },
  {
    path: 'stat-kl-posjete',
    component: StatKlPosjeteComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
